//auth
export const auth = {
  LOGIN: "LOGIN",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGIN_ERROR: "LOGIN_ERROR",
  LOGIN_FAILED: "LOGIN_FAILED",
};

//student
export const student = {
  FETCH_STUDENT: "FETCH_STUDENT",
  POST_STUDENT: "POST_STUDENT",
  POST_STUDENT_FAIL: "POST_STUDENT_FAIL",
  GET_STUDENT: "GET_STUDENT",
  GET_STUDENT_FAIL: "GET_STUDENT_FAIL",
  FILTER_STUDENT: "FILTER_STUDENT",
  GET_STUDENT_BY_ID: "GET_STUDENT_BY_ID",
  UPDATE_STUDENT: "UPDATE_STUDENT",
  DELETE_STUDENT: "DELETE_STUDENT",
};

//category
export const category = {
  FETCH_CATEGORY: "FETCH_CATEGORY",
  POST_CATEGORY: "POST_CATEGORY",
  UPDATE_CATEGORY: "UPDATE_CATEGORY",
  DELETE_CATEGORY: "DELETE_CATEGORY",
  POST_CATEGORY_FAIL: "POST_CATEGORY_FAIL",
  FETCH_LOADING_CATEGORY: "FETCH_LOADING_CATEGORY",
};

//kelas
export const kelas = {
  POST_KELAS: "POST_KELAS",
  GET_KELAS: "GET_KELAS",
  GET_JENJANG: "GET_JENJANG",
  UPDATE_KELAS: "UPDATE_KELAS",
  DELETE_KELAS: "DELETE_KELAS",
  FETCH_KELAS: "FETCH_KELAS",
  FETCH_JENJANG: "FETCH_JENJANG",
};
//tahunAjaran
export const tahunAjaran = {
  POST_TAHUNAJARAN: "POST_TAHUNAJARAN",
  GET_TAHUNAJARAN: "GET_TAHUNAJARAN",
  UPDATE_TAHUNAJARAN: "UPDATE_TAHUNAJARAN",
  DELETE_TAHUNAJARAN: "DELETE_TAHUNAJARAN",
  FETCH_TAHUNAJARAN: "FETCH_TAHUNAJARAN",
};
//Menutagihan
export const menuTagihan = {
  POST_MENUTAGIHAN: "POST_MENUTAGIHAN",
  GET_MENUTAGIHAN: "GET_MENUTAGIHAN",
  UPDATE_MENUTAGIHAN: "UPDATE_MENUTAGIHAN",
  DELETE_MENUTAGIHAN: "DELETE_MENUTAGIHAN",
  FETCH_MENUTAGIHAN: "FETCH_MENUTAGIHAN",
};
//tagihan siswa
export const tagihanSiswa = {
  FETCH_TAGIHANSISWA: "FETCH_TAGIHANSISWA",
  GET_TAGIHANSISWA: "GET_TAGIHANSISWA",
  GET_TAGIHAN_BY_NIS: "GET_TAGIHAN_BY_NIS",
};

//month
export const month = {
  FETCH_MONTH: "FETCH_MONTH",
  GET_MONTH: "GET_MONTH",
};

//tabungan
export const tabungan = {
  FETCH_TABUNGAN: "FETCH_TABUNGAN",
  GET_TABUNGAN: "GET_TABUNGAN",
  GET_TABUNGAN_BY_NIS: "GET_TABUNGAN_BY_NIS",
  GET_TABUNGAN_BY_NIS_FAIL: "GET_TABUNGAN_BY_NIS_FAIL",
  POST_TABUNGAN: "POST_TABUNGAN",
  UPDATE_TABUNGAN: "UPDATE_TABUNGAN",
  DELETE_TABUNGAN: "DELETE_TABUNGAN",
};

//tagihan siswa
export const transaksi = {
  FETCH_TRANSAKSI: "FETCH_TRANSAKSI",
  GET_TRANSAKSI: "GET_TRANSAKSI",
  POST_TRANSAKSI: "POST_TRANSAKSI",
  NULL_TRANSAKSI: "NULL_TRANSAKSI",
};

//tagihan siswa
export const laporan = {
  FETCH_LAPORAN: "FETCH_LAPORAN",
  GET_LAPORAN: "GET_LAPORAN",
  POST_LAPORAN: "POST_LAPORAN",
  NULL_LAPORAN: "NULL_LAPORAN",
};

//tagihan siswa
export const dashboard = {
  FETCH_DASHBOARD: "FETCH_DASHBOARD",
  GET_DASHBOARD: "GET_DASHBOARD",
  FETCH_DASHBOARD_TAGIHAN: "FETCH_DASHBOARD_TAGIHAN",
  GET_DASHBOARD_TAGIHAN: "GET_DASHBOARD_TAGIHAN",
  NULL_DASHBOARD_TAGIHAN: "NULL_DASHBOARD_TAGIHAN",
};
